import { render } from "./vendor-modal.vue?vue&type=template&id=f0f5c1b8"
import script from "./vendor-modal.vue?vue&type=script&lang=js"
export * from "./vendor-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__